import { i18n } from '@/assets/i18n/i18n';
export interface RequestSupportForm {
    email?: string,
    first_name?: string,
    last_name?: string,
    request_type?: number,
    message?: string,
    "g-recaptcha-response"?: string,
    lang?: string,
}
export const request_support_form = {
    request_type: undefined,
    lang: i18n.global.locale,
} as RequestSupportForm;

export const email_is_valid = (email?: string): boolean => {
    var EMAIL_PATTERN = '^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$';
    var EMAIL_REGEXP = new RegExp(EMAIL_PATTERN, 'i');
    return EMAIL_REGEXP.test(email ?? '');
}
export const clone = (object?) => JSON.parse(JSON.stringify(object));

export const toggle_password_visibility = (event?: Event) => {
    const target = event?.target as HTMLElement | null;
    const parent = target?.parentElement as HTMLElement | null;
    if(!parent) return;
    const input = parent.querySelector<HTMLInputElement>('input');
    const icon = parent.querySelector<HTMLElement>('i');
    if(input && icon) {
        switch (input.type) {
            case "password":
                input.type = "text";
                icon.classList.remove("ph-eye");
                icon.classList.add("ph-eye-slash");
                break;
            case "text":
                input.type = "password";
                icon.classList.remove("ph-eye-slash");
                icon.classList.add("ph-eye");
                break;
        }
    }
}